function wordCharactersAndSpacesFilter() {
    'ngInject';

    return string => string.replace(/[^a-zA-Z0-9\_\s]+/, '');
}

// -------------------------------------------------------------------------------------------
// filters out all non alpha-numeric characters with the exception of space and underscore
// -------------------------------------------------------------------------------------------
angular
    .module('BB')
    .filter('wordCharactersAndSpaces', wordCharactersAndSpacesFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/word_characters_and_spaces.filter.js